export default "__VITE_ASSET__BJy8LrCX__"